module.exports = __webpack_public_path__ + "img/7.a4f2cc14.jpg";